// Maps the typed failure reason from /auth/google/callback (and from the
// session exchange) to copy written for whoever is trying to sign in — what
// happened and what they can do about it. Mirrors
// features/google-workspace/lib/connectErrorCopy.ts's split: the technical
// detail (which phase failed, Google's response) lives in the API logs, not here.
const GOOGLE_SIGN_IN_ERROR_COPY: Record<string, string> = {
  missing_params: 'Google didn\'t send back what Zeph needed. Please try signing in again.',
  access_denied: 'Sign-in was cancelled. You can try again whenever you\'re ready.',
  google_token_exchange_failed: 'Google couldn\'t complete the sign-in. Please try again.',
  google_token_invalid: 'Zeph couldn\'t verify your Google identity. Please try again.',
  google_profile_incomplete: 'Zeph couldn\'t read your Google account details. Please try again.',
  google_email_unverified: 'That email isn\'t verified with Google yet, so it can\'t be linked to an existing account. Verify it with Google and try again.',
  oauth_state_expired: 'That took too long, so Zeph stopped the sign-in for safety. Please try again.',
  invalid_state: 'That sign-in link isn\'t valid anymore. Please start again.',
  account_suspended: 'This account has been suspended. Contact your workspace admin.',
  handoff_code_invalid: 'This sign-in link has expired or was already used. Please sign in again.',
}

const FALLBACK = 'Something went wrong signing in with Google. Please try again.'

export function googleSignInErrorCopy(reason: string | null): string {
  if (!reason) return FALLBACK
  return GOOGLE_SIGN_IN_ERROR_COPY[reason] ?? FALLBACK
}
